/** Match TagSearchDropdown / TeamDropdown portaled menus. */
export const PORTALED_TAG_SELECTOR_MENU_Z_INDEX = 9999;

type ScrollEventLike = Pick<Event, "target">;

/**
 * react-select 5's boolean `closeMenuOnScroll` only closes when the scroll
 * target is the document element. Nested overflow (Forecast Position table)
 * must use this function form. Keep the option list itself scrollable.
 */
export const shouldClosePortaledTagSelectorOnScroll = (
  event: ScrollEventLike
): boolean => {
  const target = event.target;
  if (!(target instanceof Element)) {
    return false;
  }
  if (
    target.getAttribute("role") === "listbox" ||
    target.closest('[role="listbox"]')
  ) {
    return false;
  }
  return true;
};

export const portaledTagSelectorMenuStyles = <
  TStyles extends Record<string, unknown>,
>(
  styles: TStyles
): TStyles & {
  menuPortal: (base: Record<string, unknown>) => Record<string, unknown>;
} => ({
  ...styles,
  menuPortal: (base) => ({
    ...base,
    zIndex: PORTALED_TAG_SELECTOR_MENU_Z_INDEX,
  }),
});
